import { DateTime } from 'luxon'

export default (date: string): string => {
  if (date === 'N/A') {
    return 'N/A'
  }
  return DateTime.fromISO(date).toLocaleString()
}
